/**
 * Created by Teo on 05/04/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchasesAggregatedPerEmployeeComparative', {
                parent: 'purchasesAggregated',
                url: '/perEmployeeComparative',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP'],
                    pageTitle: 'Purchases Aggregated Per Employee Comparative'
                },
                templateUrl: 'app/displays/adminIndex/purchasesAggregated/perEmployeeComparative/purchasesAggregatedPerEmployeeComparative.html',
                controller: 'PurchasesAggregatedPerEmployeeControllerComparative',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pharmacyVisitors: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_PHARM_VISITOR&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data});
                    }],
                    accountingDeps: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_ACCOUNTING_DEP&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data});
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
